import React from 'react'
import '../../../../Components/Popups/popup.common.css'
import styles from './ArchiveTherapistPopup.module.css'
import CustomModal from '../../../../Components/Modal/CustomModal'
import BorderedButton from '../../../../Components/Buttons/BorderedButton'
import PrimaryButton from '../../../../Components/Buttons/PrimaryButton'

const ArchiveTherapistPopup = ({ 
  onCancel, 
  onConfirm, 
  type = 'archive', // 'archive', 'archive-with-bookings', 'unarchive'
  isProcessing = false 
}) => {
  // Determine content based on type
  const getContent = () => {
    switch (type) {
      case 'archive-with-bookings':
        return {
          title: 'Archive Therapist',
          message: 'The therapist cannot be archived because there are active bookings linked to them. Please complete or cancel all active bookings before archiving.',
          showConfirmButton: false,
          cancelText: 'Cancel',
          confirmText: 'Archive Therapist'
        }
      case 'unarchive':
        return {
          title: 'Unarchive Therapist',
          message: 'Are you sure you want to unarchive this therapist member?',
          showConfirmButton: true,
          cancelText: 'Cancel',
          confirmText: 'Unarchive Therapist'
        }
      case 'archive':
      default:
        return {
          title: 'Archive Therapist',
          message: 'Are you sure you want to archive this therapist member? Archiving will remove them from the calendar and prevent any bookings from being assigned.',
          showConfirmButton: true,
          cancelText: 'Cancel',
          confirmText: 'Archive Therapist'
        }
    }
  }

  const content = getContent()

  return (
    <CustomModal
      show={true}
      onHide={onCancel}
      hideCloseButton={true}
    >
      <div className={`popup ${styles.archivePopup}`}>
        <div className="header">
          <h2>{content.title}</h2>
        </div>

        <div className="body">
          <p className={styles.archiveMessage}>
            {content.message}
          </p>
        </div>

        <div className={`footer ${!content.showConfirmButton ? styles.singleButtonFooter : ''}`}>
          <BorderedButton
            text={content.cancelText}
            onClick={onCancel}
            disabled={isProcessing}
            className={!content.showConfirmButton ? styles.singleButton : ''}
          />
          {content.showConfirmButton && (
            <PrimaryButton
              text={isProcessing ? 'Processing...' : content.confirmText}
              onClick={onConfirm}
              disabled={isProcessing}
              className={styles.confirmButton}
            />
          )}
        </div>
      </div>
    </CustomModal>
  )
}

export default ArchiveTherapistPopup

